import { quickChangePrice } from "../shared/requests-api";
import { getUserToken } from "../shared/utils";
import { sendingOffer, isNewUser } from ".";
import { logEvent } from "../shared/firebase";

export const onUpdateQuickSale = (offers, newPrice) => {
	return async function(dispatch) {
		const { id, price } = offers;
		const token = getUserToken();
		dispatch(sendingOffer(true));

		await quickChangePrice(token, id, newPrice)
			.then(res => {
				PubSub.publish("dataLayer", {
					event: "zanoxPixelAffiliateOfferer",
					zanoxPixelAffiliateOfferer: res
				});
				logEvent("price_changed", {
					new_price: newPrice,
					old_price: price
				});
				dispatch(sendingOffer(false, true, true));
				dispatch(isNewUser(false));
			})
			.catch(error => {
				dispatch(
					sendingOffer(false, false, { offer: offers, message: error.response.data.message })
				);
			});
	};
};
